import {
  browserTracingIntegration,
  replayIntegration,
  captureEvent,
  init,
  setUser as sentrySetUser,
} from '@sentry/react';
import { getCurrentRoute } from './utils';
import { getCurrentRouteObject } from '@/router/utils';

export function initialiseSentry(config: Parameters<typeof init>[0]) {
  init({
    beforeSend: (event) => {
      const route = getCurrentRouteObject();
      const team = route.team;
      const teamTagAlreadySet = event.tags?.team;

      if (team && !teamTagAlreadySet) {
        event.tags = {
          ...event.tags,
          team,
        };
      }
      return event;
    },
    integrations: [
      browserTracingIntegration({
        beforeStartSpan: (context) => {
          const route = getCurrentRoute();
          return {
            ...context,
            name: route,
          };
        },
      }),
      replayIntegration(),
    ],
    ...config,
  });
}

export function setUser(user: Parameters<typeof sentrySetUser>[0]) {
  sentrySetUser(user);
}

export const logEvent: typeof captureEvent = (event, hint) => {
  return captureEvent(event, hint);
};
